import * as React from 'react';
import {
    Route, Switch,
} from 'react-router-dom';

import urls from '../../app/urls';
import Dashboard from './Dashboard';
import Profile from './Profile';
import Page from './Page';
import NewForm from './NewForm';

class Index extends React.Component {
    render() {
        return (
            <Switch>
                <Route exact path={`${urls.inside.page}/:taskId`} component={Page} />
                <Route exact path={`${urls.inside.form}/:taskId`} component={NewForm} />
                <Route exact path={urls.inside.home} component={Dashboard} />
                <Route exact path={urls.inside.profile} component={Profile} />
                <Route component={Dashboard} />
            </Switch>
        );
    }
}

export default Index;
